function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M205.3 141.8l-127.4-.1.1 63.6 127.4.1-.1-63.6zM92 191.3v-35.6h14.4v21.4h14v-21.4h14.3v21.4h14v-21.3H163v21.3h14v-21.3h14.3v35.6l-99.3-.1zM28.3 0v255.1h78.1v28.3h28v-28.3H149v28.3h28v-28.3h78.1V0H28.3zm198.5 226.8H56.7V28.3h170.1v198.5zM78.1 56.7l-.1 63.5 127.4.1.1-63.6H78.1zm113.3 49.6l-99.4-.1V70.7h14.3V92h14V70.7h14.3V92h14V70.7h14.3V92h14V70.7h14.4l.1 35.6z"
})));